// extracted by mini-css-extract-plugin
export var childrenContainer = "_41-0";
export var virtualScrollArea = "_41-1";